import { graphql } from '@/generated/gql';

export const CREATE_RULE_SETTINGS = graphql(/* GraphQL */ `
  mutation RuleSettingsCreate($id: UUID!, $data: TsrctRuleCreateDataInput!) {
    tesseract {
      rule(id: $id) {
        create(data: $data) {
          id
          name
          responsibleUsers
        }
      }
    }
  }
`);
export const UPDATE_RULE_SETTINGS = graphql(/* GraphQL */ `
  mutation RuleSettingsUpdate($id: UUID!, $data: TsrctRuleUpdateDataInput!) {
    tesseract {
      rule(id: $id) {
        update(data: $data) {
          id
          name
          responsibleUsers
        }
      }
    }
  }
`);

export const REMOVE_RULE_SETTINGS = graphql(/* GraphQL */ `
  mutation RuleSettingsDelete($id: UUID!) {
    tesseract {
      rule(id: $id) {
        remove {
          id
        }
      }
    }
  }
`);
